import { getLifeFeedback } from '../data/lifeFeedback';

export const updateLifeHud = (hud, elapsed, reserve) => {
  if (!hud.life) return;
  const { percent, label, danger } = getLifeFeedback(elapsed, reserve);
  const changed = hud.life.dataset.value !== String(percent);
  if (changed) {
    hud.life.dataset.value = String(percent);
    hud.lifeMeter.value = percent;
    hud.lifeFill.style.transform = `scaleX(${percent / 100})`;
  }
  if (changed || hud.lifeLabel.textContent !== label) {
    hud.lifeLabel.textContent = label;
    hud.lifeMeter.setAttribute('aria-valuetext', `${percent}% de vida. ${label}, al ritmo actual.`);
  }
  hud.life.dataset.danger = String(danger);
};

export const updateHoldHud = (nodes, feedback, time) => {
  if (!nodes?.panel) return;
  nodes.panel.hidden = !feedback || time >= feedback.until;
  if (nodes.panel.hidden) return;
  const { status, progress } = feedback;
  const percent = Math.round(progress * 100);
  if (nodes.panel.dataset.state !== status) {
    nodes.panel.dataset.state = status;
    nodes.label.textContent = {
      holding: 'Mantén el pulso', resume: 'Vuelve a mantener', success: '¡Sostenido completo!', fail: 'Sostenido perdido',
    }[status];
  }
  if (nodes.meter.value !== percent) nodes.meter.value = percent;
  nodes.fill.style.transform = `scaleX(${progress})`;
};
